import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend
} from "recharts";

export default function ReactiveEnergyTrend24h({ deviceId, API_BASE }) {
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  useEffect(() => {
    async function load() {
      const res = await fetch(
        `${API_BASE}/reactive/daily-energy-history?deviceId=${deviceId}`
      );
      const json = await res.json();
      const history = json.history || [];

      const formatted = history.map((x) => ({
        time: x.hour,                         // backend: hour
        inductive: Math.trunc((Number(x.inductive) || 0) * 1000) / 1000,
        capacitive: Math.trunc((Number(x.capacitive) || 0) * 1000) / 1000,
        active: Math.trunc((Number(x.active) || 0) * 1000) / 1000,

      }));

      setData(formatted);
    }

    load();
  }, [deviceId, API_BASE]);

  // Saat formatı (2025-11-16T14:00:00+03:00 → 14:00)
  const formatHour = (t) => {
    try {
      const h = new Date(t).getHours().toString().padStart(2, "0");
      return `${h}:00`;
    } catch {
      return t;
    }
  };

  return (
    <div className="bg-white p-5 rounded-xl border shadow">
      <h3 className="text-lg font-semibold mb-3">
        {t('energies.trend24hTitle')}
      </h3>

      <ResponsiveContainer width="100%" height={320}>
        <LineChart data={data} margin={{ top: 10, right: 25, bottom: 20, left: 0 }}>
          <CartesianGrid strokeDasharray="4 4" />

          <XAxis
            dataKey="time"
            tickFormatter={formatHour}
            stroke="#6B7280"
            tick={{ fontSize: 12 }}
            height={40}
          />

          <YAxis stroke="#6B7280" tick={{ fontSize: 12 }} />

          <Tooltip
            formatter={(value, name) => [`${value} kWh`, name]}
            labelFormatter={(v) => `Saat: ${formatHour(v)}`}
          />

          <Legend
            verticalAlign="top"
            height={30}
            wrapperStyle={{ fontSize: 12 }}
          />

          <Line
            type="monotone"
            dataKey="inductive"
            stroke="#3B82F6"
            name={t('dashboard.inductive')}
            strokeWidth={2}
            dot={false}
          />

          <Line
            type="monotone"
            dataKey="capacitive"
            stroke="#F59E0B"
            name={t('dashboard.capacitive')}
            strokeWidth={2}
            dot={false}
          />

          <Line
            type="monotone"
            dataKey="active"
            stroke="#10B981"
            name={t('alarms.active')}
            strokeWidth={2.3}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
